import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class DebitNote {
  async fetch(page, perpage, search) {
    let param = `page=${page}&perPage=${perpage}`
    if (search) {
      param += `&search=${encodeURIComponent(search)}`;
    }
    const response = await ajaxService.get(`/debit-notes?${param}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async viewPDF(id) {
    const response = await ajaxService.get(`/debit-notes/pdf/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addDebitNote(data) {
    const response = await ajaxService.post(`/debit-notes/store`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const debitNoteService = new DebitNote();

export default debitNoteService;
